import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { HighlightOffRounded } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import request from '../../services/Request';
import logger from '../../services/LocalServer/logger';
import { sleep } from '../../services/methods';
import Swal from 'sweetalert2';

export default function ScanModel(props) {
  const preDateRef = useRef(new Date(0));
  const { t } = useTranslation();
  const {
    products,
    cleanUp,
    add,
    show,
    onHide,
    setLoading,
    clientUser,
    setClientUser,
    machineData,
    alterquantity,
    decreStock,
    cart,
  } = props;

  // useEffect(() => {
  //   if (show) {
  //     request({
  //       method: 'POST',
  //       url: '/loginClientUser/machineLogin',
  //       data: {
  //         _id: `683f2c7c5274ddece1c1787e`,
  //         referTo: 'tianlangwu001@gmail.com',
  //       },
  //       timeout: 4000,
  //     })
  //       .then(async (res) => {
  //         Swal.fire({
  //           icon: 'success',
  //           title: `Welcome back ${res.data.username}!`,
  //           allowOutsideClick: false,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  //         console.log('loginUser', res.data);
  //         setClientUser(res.data);
  //         if (res.data?.add_to_cart?.products?.length > 0) {
  //           if (cart?.length > 0) {
  //             cleanUp();
  //           } else {
  //             addProductToCart(res.data);
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         logger(0, 'Errors when login to machine Client' + JSON.stringify(err));
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Login failed',
  //           allowOutsideClick: false,
  //           showConfirmButton: false,
  //           timer: 2000,
  //         });
  //         console.log('error', err);
  //       });
  //   }
  // }, [show]);

  const logout = () => {
    setClientUser(null);
  };

  useEffect(() => {
    let barcode = '';
    let timeoutId;

    const readBarcode = (evt) => {
      // Clear previous timeout
      clearTimeout(timeoutId);

      // Enter key signals end of barcode
      if (evt.code === 'Enter') {
        if (barcode) handleBarcode(barcode);
        barcode = '';
        return;
      }

      // Append key, excluding modifiers
      if (
        evt.key.length === 1 &&
        evt.code !== 'Shift' &&
        evt.code !== 'ShiftLeft' &&
        evt.code !== 'ShiftRight'
      ) {
        barcode += evt.key;
      }

      // Reset barcode after 150ms of inactivity
      timeoutId = setTimeout(() => {
        barcode = '';
      }, 150);
    };

    const handleBarcode = async (bq) => {
      const nowDate = new Date();
      document?.activeElement?.blur();

      // Add scan cooldown 5 seconds
      if (nowDate.getTime() - preDateRef.current.getTime() > 5000 && show) {
        preDateRef.current = nowDate;
        let valid = true;

        let barcodeData = null;
        try {
          barcodeData = JSON.parse(bq);
          console.log('parseBarcode', barcodeData);
          if (barcodeData?._id) {
            request({
              method: 'POST',
              url: '/loginClientUser/machineLogin',
              data: {
                _id: barcodeData?._id,
                referTo: machineData?.belongTo,
              },
              timeout: 4000,
            })
              .then(async (res) => {
                Swal.fire({
                  icon: 'success',
                  title: `Welcome back ${res.data.username}!`,
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 3000,
                });
                console.log('loginUser', res.data);
                setClientUser(res.data);
                if (res.data?.add_to_cart?.products?.length > 0) {
                  if (cart?.length > 0) {
                    cleanUp();
                  } else {
                    addProductToCart(res.data);
                  }
                }
              })
              .catch((err) => {
                logger(0, 'Errors when login to machine Client' + JSON.stringify(err));
                Swal.fire({
                  icon: 'error',
                  title: 'Login failed',
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 2000,
                });
                console.log('error', err);
                valid = false;
              });
          }
        } catch (error) {
          console.log('parseBarcode', error);
          valid = false;
        }

        logger(2, '[Barcode]| Barcode Entered: ' + bq);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please wait for 5 seconds before scanning again',
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    };

    if (show) {
      console.log('addevent listener');
      document.addEventListener('keydown', readBarcode);
    }

    return () => {
      console.log('remove');
      document.removeEventListener('keydown', readBarcode);
    };
  }, [show]);

  const addProductToCart = async (clientUser) => {
    console.log('addProductToCart', clientUser);
    if (clientUser?.add_to_cart?.products?.length > 0) {
      let clientProduct = clientUser?.add_to_cart?.products;
      console.log('productsproductsproductsproducts', products);
      //add quantity to clientProduct if there same products
      let newArray = [];
      clientProduct.forEach((item) => {
        if (newArray.findIndex((e) => e?.id?._id === item?.id._id) === -1) {
          item.quantity = 1;
          newArray.push(item);
        } else {
          newArray[newArray.findIndex((e) => e?.id?._id === item?.id?._id)].quantity += 1;
        }
      });

      console.log('clienProduct', newArray);
      //check does machine has enough stock
      let stock = true;
      newArray.forEach((item) => {
        let idx = products.findIndex((e) => e._id === item?.id?._id);
        if (idx > -1) {
          if (products[idx].current_stock < item.quantity) {
            stock = false;
            return;
          }
        } else {
          stock = false;
        }
      });
      if (!stock) {
        Swal.fire({
          icon: 'error',
          text: 'Not enough stock',
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 2000,
        });

        return;
      } else {
        //add products to cart
        // console.log('currentCart', cart);
        // return;
        newArray.forEach((item) => {
          const findProduct = products.findIndex((e) => e._id === item?.id?._id);
          item.localProduct = products[findProduct];
          item.localProduct.quantity = item.quantity;
          console.log('item', item);
          addToCart(item.localProduct);
        });
        clientUser.finish_order = true;
        // let pdd = JSON.parse(localStorage.getItem('products'));
        // console.log('products', pdd);
      }
    }
  };

  const addToCart = async (ptheProd) => {
    console.log('addToCart', ptheProd);
    if (ptheProd.current_stock > 0) {
      decreStock(ptheProd, ptheProd.current_stock - ptheProd.quantity);

      add({
        idx: parseInt(ptheProd.idx),
        id: ptheProd._id,
        _id: ptheProd._id,
        key: ptheProd._id,
        limit: ptheProd.limit,
        upc: ptheProd?.upc,
        name: ptheProd.name,
        title: ptheProd.name,
        pop_alert: ptheProd.pop_alert,
        promo: ptheProd.promo,
        price: ptheProd.price,
        discount: ptheProd.discount ? ptheProd.discount : 0,
        percentage: ptheProd.percentage,
        discountedPrice: ptheProd.discountedPrice ?? ptheProd.price,
        image: ptheProd.productPictures[0],
        buyX: ptheProd.buyX ? ptheProd.buyX : 0,
        quantity: ptheProd.quantity,
        category: ptheProd.category,
        ingredients: ptheProd.ingredients,
        referTo: ptheProd.referTo,
        prodType: ptheProd.prodType,
        current_stock: ptheProd.current_stock,
        emailCode: ptheProd.emailCode,
        addition: ptheProd.addition,
        tax_type: ptheProd.tax_type,
        bundle_prod: ptheProd.bundle_prod,
      });
    }
  };

  useEffect(() => {
    if (show && clientUser?.add_to_cart?.products?.length > 0) {
      if (cart.length === 0) {
        // Once cart is cleared, perform the next action
        console.log('Cart cleaned up. Proceeding to add...');
        addProductToCart(clientUser);
        // add(productToAdd);
      }
    }
  }, [cart]);

  // useEffect(() => {
  //   if (show) {
  //     request({
  //       method: 'POST',
  //       url: '/loginClientUser/machineLogin',
  //       data: {
  //         _id: `6734c61113d9eb42fbd11a91`,
  //         referTo: machineData?.belongTo,
  //       },
  //       timeout: 4000,
  //     })
  //       .then(async (res) => {
  //         Swal.fire({
  //           icon: 'success',
  //           title: `Welcome back ${res.data.username}!`,
  //           allowOutsideClick: false,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  //         console.log('loginUser', res.data);
  //         setClientUser(res.data);
  //         if (res.data?.add_to_cart?.products?.length > 0) {
  //           if (cart?.length > 0) {
  //             cleanUp();
  //           } else {
  //             addProductToCart(res.data);
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Login failed',
  //           allowOutsideClick: false,
  //           showConfirmButton: false,
  //           timer: 2000,
  //         });
  //         console.log('error', err);
  //       });
  //   }
  // }, [show]);

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body className="ui-bg-color promo-modal">
        <HighlightOffRounded
          className="close_circle_icon"
          style={{ fontSize: '40px', marginTop: '0px' }}
          onClick={() => {
            props.onHide();
          }}
        />
        <div
          id="close_promo_modal"
          onClick={() => {
            props.onHide();
          }}
        ></div>
        <Container>
          <div className="d-flex flex-column align-items-center justify-content-center mt-4 pb-4">
            {clientUser?._id ? (
              <div>
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div className="promo-text mb-2">{`Welcome ${clientUser.username}!`}</div>
                  <div className="promo-text mb-2">{`Points:${clientUser.points}`}</div>
                  <div className="d-flex flex-column align-items-center justify-content-center mt-3">
                    <button
                      className="btn "
                      style={{ backgroundColor: '#2a5989', color: '#fff' }}
                      onClick={logout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
                {/* <div>
                  {clientUser?.clientPromo?.map((item, index) => {
                    return (
                      <div key={index} className="promo-text mb-2">
                        Discount Card: ${item.amount}
                      </div>
                    );
                  })}
                </div> */}
              </div>
            ) : (
              <div className="promo-text mb-5">{t(`Scan Your QR Code To Login`)}</div>
            )}
            <div></div>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
